import React, { createContext, useContext, ReactNode } from 'react';
import { useDropdown } from '../hooks/useDropdown';

const DropdownContext = createContext<ReturnType<typeof useDropdown> | undefined>(undefined);

export const useDropdownContext = () => {
  const context = useContext(DropdownContext);
  if (context === undefined) {
    throw new Error('useDropdownContext must be used within a DropdownProvider');
  }
  return context;
};

interface DropdownProviderProps {
  children: ReactNode;
}

export const DropdownProvider: React.FC<DropdownProviderProps> = ({ children }) => {
  const dropdownHook = useDropdown();

  return (
    <DropdownContext.Provider value={dropdownHook}>
      {children}
    </DropdownContext.Provider>
  );
};
